"use client"
import DocumentEventHandler from "@directv-digital/dds.ui.document-event-handler";

export function DocumentEventHandlerClient(){
  return <DocumentEventHandler />
}

export default DocumentEventHandlerClient;
